import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

interface IGetReporte {
  cuit: string;
  obra_social: string;
  solapa: string;
  periodo_desde: string;
  periodo_hasta: string;
  fecha_tramite_desde: string;
  fecha_tramite_hasta: string;
}

@Injectable({
  providedIn: 'root'
})
export class LiquidadorService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(environment.urlApi + '');
  }

  getLiquidaciones(sessionId, filters = {}, page = 1, pageSize = 10, sortBy = '', sortOrder = ''): Observable<any[]> {
    const headers = new HttpHeaders({
      sessionid: sessionId
    });
    const body = {
      filters: filters,
      page: page,
      pageSize: pageSize,
      sortBy: sortBy,
      sortOrder: sortOrder
    };

    return this.http.post<any[]>(environment.urlApi + 'liquidador/getLiquidaciones', body, { headers });
  }

  getLiquidacion(id): Observable<any[]> {
    return this.http
      .get<any[]>(environment.urlApi + 'liquidador/getLiquidacion?id=' + id)
      .pipe(catchError(error => throwError(() => error)));
  }

  getFactura(cuit, NroFactura, TipoFactura, SucurFactura, SerieFactura): Observable<any[]> {
    return this.http
      .get<
        any[]
      >(environment.urlApi + 'liquidador/getFactura?cuit=' + cuit + '&nroFactura=' + NroFactura + '&tipoFactura=' + TipoFactura + '&sucurFactura=' + SucurFactura + '&serieFactura=' + SerieFactura)
      .pipe(catchError(error => throwError(() => error)));
  }

  getReporte(filtros: IGetReporte): Observable<any> {
    const body = {
      cuit: filtros.cuit,
      obra_social: filtros.obra_social,
      solapa: filtros.solapa,
      periodo_desde: filtros.periodo_desde,
      periodo_hasta: filtros.periodo_hasta,
      fecha_tramite_desde: filtros.fecha_tramite_desde,
      fecha_tramite_hasta: filtros.fecha_tramite_hasta
    };

    return this.http
      .post<any>(environment.urlApi + 'liquidador/getReporte', body)
      .pipe(catchError(error => throwError(() => error)));
  }
  getPlantilla(cuit, NroFactura): Observable<any[]> {
    return this.http
      .get<any[]>(environment.urlApi + 'liquidador/getPlantilla?cuit=' + cuit + '&nroFactura=' + NroFactura)
      .pipe(catchError(error => throwError(() => error)));
  }
  getObrasSocialesProveedor(sessionId): Observable<any> {
    const headers = new HttpHeaders({
      sessionid: sessionId
    });
    return this.http
      .get(`${environment.urlApi}proveedor/getObrasSocialesProveedor`, { headers })
      .pipe(catchError(error => throwError(() => error)));
  }
}
